// Geography helpers. All distances are real haversine miles on lat/lon —
// the old flat mile-plane (x/y from an Astoria origin) is gone. Anything
// with a position carries { lat, lon }.

const EARTH_RADIUS_MI = 3958.8;

export function haversineMiles(lat1, lon1, lat2, lon2) {
  const rad = Math.PI / 180;
  const dLat = (lat2 - lat1) * rad;
  const dLon = (lon2 - lon1) * rad;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1 * rad) * Math.cos(lat2 * rad) * Math.sin(dLon / 2) ** 2;
  return 2 * EARTH_RADIUS_MI * Math.asin(Math.sqrt(a));
}

// activity and base both carry lat/lon
export function milesFrom(activity, base) {
  if (activity?.lat == null || base?.lat == null) return Infinity;
  return haversineMiles(activity.lat, activity.lon, base.lat, base.lon);
}

export function fmtMiles(mi) {
  if (!isFinite(mi)) return '';
  if (mi < 0.1) return '<0.1 mi';
  if (mi < 10) return mi.toFixed(1) + ' mi';
  return Math.round(mi) + ' mi';
}

export function distLabel(activity, base) { return fmtMiles(milesFrom(activity, base)); }
